"use client";

import { isSanityImageURL, isStaticImage } from "@/apiUtils/commonUtils";
import sanityImageLoader from "@/apiUtils/sanity/utils";
import NextImage, { ImageProps } from "next/image";
import { useState, useEffect } from "react";

interface NextImageProps extends ImageProps {
  dataSanity?: string;
  fallbackSrc?: string;
}

const Image = ({
  src,
  dataSanity,
  fallbackSrc,
  width,
  height,
  ...rest
}: NextImageProps): JSX.Element => {
  const [imgSrc, setImgSrc] = useState(src ?? "/magrabi/images/no-image-rectangle.svg");

  useEffect(() => {
    setImgSrc(src);
  }, [src]);

  if (typeof src === "string" && isSanityImageURL(src)) {
    return (
      <NextImage
        width={width}
        height={height}
        data-sanity={dataSanity}
        src={src}
        loader={(loaderProps) =>
          sanityImageLoader({ ...loaderProps, imageWidth: width, imageHeight: height })
        }
        {...rest}
      />
    );
  }

  return (
    <NextImage
      src={imgSrc}
      width={width}
      height={height}
      unoptimized={isStaticImage(imgSrc as string)}
      {...rest}
      quality={95}
      data-sanity={dataSanity}
      onError={() => setImgSrc(fallbackSrc ?? "/magrabi/images/no-image-rectangle.svg")}
    />
  );
};

export default Image;
